import { Card, CardContent, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { formatCronExpression } from "@/pages/subscriptions/components/list/utils/cronFormatter";
import { DbtCloudConnectionResponse } from "../../types";
import { DetailRow } from "./DetailRow";

interface DetailsCardProps {
  connection: DbtCloudConnectionResponse;
}

export const DetailsCard = ({ connection }: DetailsCardProps) => {
  return (
    <Card>
      <CardContent className="al-h-full !al-p-6">
        <Stack direction="column" gap="lg">
          <Typography variant="section-heading">Details</Typography>

          <Stack direction="column" gap="md">
            <DetailRow label="API URL" value={connection.api_base_url} />
            <DetailRow
              label="Schedule"
              value={formatCronExpression(connection.schedule?.cron_expr || "0 0 * * *")}
            />
            <DetailRow
              label="Lookback"
              value={`${connection.schedule?.lookback_days || 30} days`}
            />
            <DetailRow label="Account ID" value={connection.account_id} />
            <DetailRow
              label="Status"
              value={connection.is_active ? "Active" : "Inactive"}
              valueClassName={connection.is_active ? "al-text-green-600" : "al-text-red-600"}
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
